import { render, staticRenderFns } from "./my-act.vue?vue&type=template&id=4946a9cc&scoped=true&"
import script from "./my-act.vue?vue&type=script&lang=js&"
export * from "./my-act.vue?vue&type=script&lang=js&"
import style0 from "./my-act.vue?vue&type=style&index=0&id=4946a9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4946a9cc",
  null
  
)

export default component.exports